import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import BooksetHorizontalCard from 'rebook/apps/catalog/components/BooksetHorizontalCard';

import styles from './style.scss';


const BooksetList = ({ booksets, title, ...sliderSettings }) => (
  <React.Fragment>
    {title && (
      <div className={classNames(styles.title, 'title-2')}>{title}</div>
    )}
    <ContentCarousel {...sliderSettings} withNav>
      {booksets.map((bookset) => (
        <BooksetHorizontalCard
          key={bookset.id}
          bookset={bookset} />
      ))}
    </ContentCarousel>
  </React.Fragment>
);

BooksetList.propTypes = {
  booksets: PropTypes.array.isRequired,
  title: PropTypes.string,
};

export default BooksetList;
